import type { SkillQuality } from '@/types/skill'
import { formatNumber } from '@/utils'

export const extraDamageCollection: Record<number, { desc: ({}: { skillId: number; data: any; quality: SkillQuality }) => string }> = {
  40001: {
    desc: ({ data }) => `当敌方存在<span class="info">麻痹</span>效果时，额外造成 <span class="grow">${formatNumber(data.multiplier, 2)}%</span>伤害`,
  },
  40002: {
    desc: ({ data }) => `当敌方存在<span class="info">灼烧</span>效果时，额外造成 <span class="grow">${formatNumber(data.multiplier, 2)}%</span>伤害`,
  },
  40003: {
    desc: ({ data }) => `当敌方存在<span class="info">冰冻</span>效果时，额外造成 <span class="grow">${formatNumber(data.multiplier, 2)}%</span>伤害`,
  },
  40004: {
    desc: ({ data }) => `当敌方存在<span class="info">石化</span>效果时，额外造成 <span class="grow">${formatNumber(data.multiplier, 2)}%</span>伤害`,
  },
  50013: {
    desc: ({ data }) => `当敌方不存在<span class="info">冰冻</span>效果时，降低 <span class="shrink">${formatNumber(data.multiplier, 2)}%</span>伤害`,
  },
  50014: {
    desc: ({ data }) => `当敌方不存在<span class="info">麻痹</span>效果时，降低 <span class="shrink">${formatNumber(data.multiplier, 2)}%</span>伤害`,
  },
  50015: {
    desc: ({ data }) => `当敌方不存在<span class="info">石化</span>效果时，降低 <span class="shrink">${formatNumber(data.multiplier, 2)}%</span>伤害`,
  },
  50016: {
    desc: ({ data }) => `当敌方不存在<span class="info">灼烧</span>效果时，降低 <span class="shrink">${formatNumber(data.multiplier, 2)}%</span>伤害`,
  },
}
